import { SET_NON_REVIEWED_DATA } from "../../redux/actions/action.types";

export default function setNonReviewedData(stateHandler: any, data: any) {
  stateHandler({
    type: SET_NON_REVIEWED_DATA,
    payload: data,
  });
}
